"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MimeDB = void 0;
exports.MimeDB = {
    "image/bmp": ["bmp", "rle", "dib"],
    "image/gif": ["gif"],
    "image/iff": ["iff", "tdi"],
    "image/jpeg": ["jpg", "jpeg", "jpe"],
    "image/png": ["png"],
    "image/tiff": ["tif", "tiff"],
    "image/vnd.adobe.photoshop": ["psd", "psb"],
    "image/vnd.fpx": ["fpx"],
    "image/vnd.microsoft.cursor": ["cur"],
    "image/vnd.microsoft.icon": ["ico"],
    "image/vnd.neptunelabs.storage": ["eis"],
    "image/vnd.radiance": ["hdr", "rgbe"],
    "image/x-apple-icons": ["icns"],
    "image/x-dcx": ["dcx"],
    "image/x-pcx": ["pcx"],
    "image/x-pict": ["pct", "pict"],
    "image/x-portable-pixmap": ["pnm", "pbm", "pgm", "ppm", "pam", "pfm"],
    "image/x-sgi": ["sgi"],
    "image/x-tga": ["tga", "targa", "vda", "icb", "vst"]
};
